import { components } from '@doltech/dto';
import { SkillEnum, TestTypeEnum } from '@doltech/utils/lib/constants';
import { useStore } from 'mobx-store-provider';

import { ViewTestSubjectStore } from './view-test-subject.store';

export const getInitializeViewTestSubjectStore = (data, testType) => {
  const result: any = {
    isBookmark: false,
  };

  result.initialed = true;
  result.createdAt = data.createdAt;
  result.id = data.id;
  result.lastModifiedAt = data.lastModifiedAt;
  result.name = data.name;
  result.skill = data.skill as SkillEnum;
  result.testType = testType as TestTypeEnum;

  if (testType === 'PRACTICE_TEST') {
    const testData = data as components['schemas']['TestSectionDTO'];
    result.totalSections = 1;
    result.testSections = [testData];
  } else {
    const testData = data as components['schemas']['TestDetailDTO'];
    result.totalSections = testData.testSections?.length;
    result.testSections = testData.testSections;
  }

  return result;
};

export const useViewTestSubjectStore = () => {
  return useStore(ViewTestSubjectStore);
};
